import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLeftMedium"><Path d="M15.5605 5.75L9.31055 12L15.5605 18.25L14.5 19.3105L7.18945 12L14.5 4.68945L15.5605 5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftMedium;
